import { Button } from "@ui";
import style from "./SettingsPage.module.scss";
import { useEffect, useRef } from "react";
import { FormikProps } from "formik";
import { GenerateToken, PasswordForm, UserInfoForm } from "./components";
import { useChangeUserPasswordMutation, useChangeUserProfileDataMutation } from "@RTKQuery/user/auth/auth";
import { IPassword, IUser } from "@interfaces/user/user";

export function SettingsPage() {
    const [changeUserProfileData, statusProfile] = useChangeUserProfileDataMutation();
    const [changeUserPassword, statusPassword] = useChangeUserPasswordMutation();

    const user = useRef<FormikProps<Pick<IUser, "first_name" | "last_name" | "phone_number" | "email" | "instagram" | "telegram">>>(null);
    const password = useRef<FormikProps<IPassword>>(null);

    const handleSubmitAll = async () => {
        await user.current?.submitForm();
        await password.current?.submitForm();

        if (user.current && password.current) {
            if (user.current.isValid && password.current.isValid) {
                changeUserProfileData(user.current.values)
                password.current.setTouched({})
            }
            if (password.current.isValid && password.current.values.oldPassword && user.current.isValid) {
                changeUserPassword({
                    old_password: password.current.values.oldPassword,
                    new_password: password.current.values.newPassword,
                    new_password_again: password.current.values.confirmPassword
                })
                    .unwrap()
                    .then(() => {
                        password.current?.resetForm()
                    })
                    .catch(() => { })
            }
        }
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (statusProfile.isSuccess && (statusPassword.isSuccess || statusPassword.isUninitialized)) {
            timer = setTimeout(() => {
                statusProfile.reset();
                statusPassword.reset();
            }, 3000)
        }

        return () => {
            clearTimeout(timer);
        }
    }, [statusProfile, statusPassword]);

    return (
        <main className={style.page}>
            <div className="flex justify-between w-full items-center pt-[45px] mb-[40px] max-md:flex-col max-md:items-start max-md:gap-[20px] max-md:mb-[20px] max-md:pt-[15px]">
                <p className={style.pageName}>Редагувати профіль</p>
                <Button
                    type="button"
                    text="Зберегти"
                    color="blue"
                    customStyle={{
                        button: "!min-w-[190px] !h-[40px]"
                    }}
                    onClick={() => {
                        handleSubmitAll()
                    }}
                    loading={statusProfile.isLoading || statusPassword.isLoading}
                    successContent={
                        statusProfile.isSuccess && (statusPassword.isUninitialized || statusPassword.isSuccess)
                        ?   {
                            title: "Вітаємо!",
                            description: <><span className="font-bold">Всі зміни в обліковому записі <br /> успішно збережено.</span> <br /> Приємного користування.</>
                        }
                        : undefined
                    }
                    errors={[
                        (statusProfile.error && ((extractError) => {
                            return extractError(statusProfile.error)
                        })),
                        (statusPassword.error && ((extractError) => {
                            const err = extractError(statusPassword.error)

                            return err === "Failed to change user password" ? {
                                title: "От халепа!",
                                description: <>Ви ввели невірний старий пароль.</>
                            } : err
                        }))
                    ]}
                    resetStatus={() => {
                        statusProfile.reset();
                        statusPassword.reset();
                    }}
                />
            </div>
            <div className="flex gap-[20px] items-start max-md:flex-col ">
                <UserInfoForm ref={user} />
                <div className="max-w-[540px] flex flex-col gap-[20px] grow max-md:max-w-full max-md:w-full">
                    <PasswordForm ref={password} />
                    <GenerateToken />
                </div>
            </div>
        </main>
    )
}